(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["med-trial-card"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('med-sold-meter')) {
  customElements.define('med-sold-meter', class extends HTMLElement {
    connectedCallback() {
      this.setupTask = setTimeout(() => {
        if (!this.isConnected) return;
        this.fill = this.querySelector('.med-trial__sold-fill');
        this.label = this.querySelector('.med-trial__sold-label');
        if (!this.fill || !this.label) return;
        this.target = Math.max(0, Math.min(100, Number(this.dataset.percent) || 0));
        this.template = this.dataset.label || '[percent]% Sold';
        this.duration = Math.max(1, Math.min(10, Number(this.dataset.duration) || 5)) * 1000;
        this.render(this.target);
        if (this.dataset.animate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.fill.style.width = '0%';
        this.render(0);
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.frame = requestAnimationFrame(() => {
              this.classList.add('is-animated');
              this.frame = requestAnimationFrame(() => this.start());
            });
          }
        }, { threshold: 0.5 });
        this.observer.observe(this);
      }, 0);
    }
    render(value) { this.label.textContent = this.template.replaceAll('[percent]', String(value)); }
    start() {
      this.fill.style.width = this.target + '%';
      const started = performance.now();
      const tick = now => {
        if (!this.isConnected) return;
        const progress = Math.min(1, (now - started) / this.duration);
        this.render(Math.round(this.target * (1 - Math.pow(1 - progress, 3))));
        if (progress < 1) this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      clearTimeout(this.setupTask);
      cancelAnimationFrame(this.frame);
      if (this.observer) this.observer.disconnect();
    }
  });
}

if (!customElements.get('med-trial-clock')) {
  customElements.define('med-trial-clock', class extends HTMLElement {
    connectedCallback() {
      this.startTask = setTimeout(() => {
        if (!this.isConnected) return;
        this.minutesNode = this.querySelector('[data-trial-minutes]');
        this.secondsNode = this.querySelector('[data-trial-seconds]');
        if (!this.minutesNode || !this.secondsNode) return;
        const duration = Math.max(1, Math.min(60, Number(this.dataset.minutes) || 10));
        this.deadline = Date.now() + duration * 60000;
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }, 0);
    }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      this.minutesNode.textContent = String(Math.floor(remaining / 60)).padStart(2, '0');
      this.secondsNode.textContent = String(remaining % 60).padStart(2, '0');
      if (remaining === 0) clearInterval(this.interval);
    }
    disconnectedCallback() { clearTimeout(this.startTask); clearInterval(this.interval); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml10-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ml10-sticky')) {
  customElements.define('ml10-sticky', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const update = () => {
        this.frame = null;
        this.hidden = window.scrollY < window.innerHeight;
      };
      const schedule = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', schedule, {passive: true, signal});
      window.addEventListener('resize', schedule, {signal});
      window.addEventListener('pageshow', schedule, {signal});
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
